<template>
  <div @click="onGlobalSound">
    <IconButton rounded v-show="isMuted">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 275.64 214.52"><path fill="white" class="cls-1" d="M193.23,97.89H264.3c15.12,0,15.12,18.15,0,18.15H193.23C179.62,116,179.62,97.89,193.23,97.89Z"/><path  fill="white" class="cls-1" d="M145.92,14.46V200.19c-3.17,44.12-75.85-27.69-89.11-27.69H8.65c-6.06,0-8.65-2.88-8.65-9.23V51.66c0-2.31,1.44-9.52,9.52-9.52h47C70.07,42.14,142.46-30,145.92,14.46Z"/></svg>
    </IconButton>
    <IconButton rounded v-show="!isMuted">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 275.64 214.52"><path fill="white" class="cls-1" d="M193.23,97.89H264.3c15.12,0,15.12,18.15,0,18.15H193.23C179.62,116,179.62,97.89,193.23,97.89Z"/><path fill="white" class="cls-1" d="M145.92,14.46V200.19c-3.17,44.12-75.85-27.69-89.11-27.69H8.65c-6.06,0-8.65-2.88-8.65-9.23V51.66c0-2.31,1.44-9.52,9.52-9.52h47C70.07,42.14,142.46-30,145.92,14.46Z"/><path fill="white" class="cls-1" d="M238.41,70.86v71.07c0,15.12-18.15,15.12-18.15,0V70.86C220.26,57.25,238.41,57.25,238.41,70.86Z"/></svg>
    </IconButton>
  </div>
</template>

<script>
import IconButton from '@/components/IconButton'
import useSound from 'vue-use-sound'
import buttonSfx from '@/assets/audio/sprite.mp3'
// import {inject, watch} from 'vue'
import emitter from '@/emitter'
import { onMounted, ref, onBeforeUnmount, inject } from 'vue'

export default {
  components: {
      IconButton,
  },
  setup() {
    const store = inject('store')
    const isMuted = ref(false)

    const [play, exposed] = useSound(buttonSfx,{
      loop: true,
      sprite: {
        clairiere: [0, 15000],
        bambous: [16000, 10000],
      },
    })

    function onGlobalSound() {
      if (isMuted.value) {
         if (exposed.isPlaying.value) return
        play({id: store.state.currentSound})
      } else {
        exposed.pause()
      }
      isMuted.value = !isMuted.value
    }

    function onSound(e) {
      if (e) {
        if (isMuted.value || exposed.isPlaying.value) return
        play({id: store.state.currentSound })
      } else {
        exposed.pause()
      }
    }

    function changeSound(value) {
      exposed.pause()
      exposed.stop()
      if (value) store.sound(value)
      play({id: store.state.currentSound })
    }

    onMounted(() => {
      emitter.on('SOUND', onSound)
      emitter.on('SOUND:switch', changeSound)
    })

    onBeforeUnmount(() => {
      emitter.off('SOUND', onSound)
      emitter.off('SOUND:switch', changeSound)
    })

    // watch(
    //   () => store,
    //   (store) => {
    //     console.log(
    //       "deep",
    //       store.state.currentSoundisMuted
    //     );
    //     if (store.state.currentSoundisMuted) {
    //       exposed.pause()
    //     } else {
    //       play({id: 'bambous'})
    //     }
    //   },
    //   { deep: true }
    // );

    return {
      play,
      isMuted,
      onGlobalSound,
    }
  },
}

</script>

<style lang="stylus" scoped>

</style>